module.exports = __webpack_public_path__ + "img/banner-principal.9d729017.svg";